var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPriceTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#price-tag_svg__clip0)",
    fill: "#928E9E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.414 12A1.995 1.995 0 015 11.414L.293 6.707A1 1 0 010 6V1a1 1 0 011-1h5a1 1 0 01.707.293L11.414 5a2 2 0 010 2.829l-3.586 3.585A1.994 1.994 0 016.414 12zM2 5.586L6.414 10 10 6.414 5.586 2H2v3.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5a1 1 0 100-2 1 1 0 000 2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "price-tag_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}

export default SvgPriceTag;